module.exports = __webpack_public_path__ + "static/media/FolsomLogo.d92cf0ac.png";